import { render, staticRenderFns } from "./PlatformScheduling.vue?vue&type=template&id=4c5b14db&scoped=true&"
import script from "./PlatformScheduling.vue?vue&type=script&lang=js&"
export * from "./PlatformScheduling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b14db",
  null
  
)

export default component.exports